<div class="bids-content">
  <ng-container *ngIf="bids$ | async as bids; else loading">
    <div class="bids-container">
      <app-market-item *ngFor="let item of bids.items"
                       [name]="item.baseItem.shortName || item.baseItem.name"
                       [weapon]="item.baseItem.icon"
                       [price]="item.price"
                       [color]="item.baseItem.color"
                       [exterior]="item.baseItem.exterior"
                       [skin]="item.baseItem.skin"
                       [nextStatusAt]="item.nextStatusAt"
                       [status]="item.status"
                       [phase]="item.phase"
                       [statTrak]="item.baseItem.statTrak">
      </app-market-item>
    </div>

    <p *ngIf="!bids.items.length" class="empty-data">Предметов нет</p>
  </ng-container>
</div>

<ng-template #loading>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>

